var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    width: 24,
    height: 24,
    rx: 12,
    transform: "rotate(90 24 0)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9994 8.98556C12.1135 8.98556 12.2241 9.0048 12.3311 9.04326C12.4382 9.08173 12.5385 9.14775 12.6321 9.24134L17.1417 13.7509C17.2866 13.8958 17.3564 14.0689 17.3513 14.2702C17.3462 14.4714 17.2712 14.6445 17.1263 14.7894C16.9814 14.9343 16.8058 15.0067 16.5994 15.0067C16.393 15.0067 16.2174 14.9343 16.0725 14.7894L11.9994 10.7163L7.91092 14.8048C7.76606 14.9496 7.59298 15.0195 7.3917 15.0144C7.19043 15.0093 7.01737 14.9343 6.8725 14.7894C6.72762 14.6445 6.65518 14.4689 6.65518 14.2625C6.65518 14.0561 6.72762 13.8804 6.8725 13.7356L11.3667 9.24134C11.4603 9.14775 11.559 9.08173 11.6629 9.04326C11.7667 9.0048 11.8789 8.98556 11.9994 8.98556Z",
    fill: "#76889A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.fc13a6ab22bc8bc46260b48b443bc3b0.svg";
export { ForwardRef as ReactComponent };